import { createReducer, on } from '@ngrx/store';

import { SelectDashboard, SetDashboardConfiguration, SetDashboardLoader, SetDashboards } from '../actions';
import * as sessionActions from '../actions/session.actions';
import { dashboardState } from '../states';

export const DASHBOARD_REDUCER_KEY = 'dashboard';
export const DASHBOARD_REDUCER = createReducer(
    dashboardState,
    on(sessionActions.SetCurrentOrganization, (state, action) => {
        return {
            ...state,
            currentOrganizationId: action.organization?.id,
        };
    }),
    on(SelectDashboard, (state, action) => {
        return {
            ...state,
            selectedDashboard: action.dashboard,
        };
    }),
    on(SetDashboards, (state, action) => {
        return {
            ...state,
            analyticDashboards: {
                ...state?.analyticDashboards,
                [action.currentOrganizationId]: {
                    ...state?.analyticDashboards?.[action?.currentOrganizationId],
                    dashboards: action.analyticDashboards,
                },
            },
        };
    }),
    on(SetDashboardLoader, (state, action) => {
        return {
            ...state,
            isDashboardsLoading: action.isDashboardsLoading,
        };
    }),
    on(SetDashboardConfiguration, (state, action) => {
        return {
            ...state,
            analyticDashboards: {
                ...state?.analyticDashboards,
                [action.organizationId]: {
                    ...state?.analyticDashboards?.[action?.organizationId],
                    dashboardDetails: {
                        ...state?.analyticDashboards?.[action?.organizationId]?.dashboardDetails,
                        [action.serviceId]: {
                            ...state?.analyticDashboards?.[action?.organizationId]?.dashboardDetails?.[action.serviceId],
                            configuration: action.configuration,
                            metadata: action.configuration?.filteringAttributes?.reduce((acc, item) => {
                                const newItem = { ...item };
                                delete newItem.value;
                                acc.push(newItem);
                                return acc;
                            }, [] as any[]),
                        },
                    },
                },
            },
        };
    }),
    on(sessionActions.SessionLogoutSuccessfull, () => dashboardState)
);

